import { Positions } from './interest-positions';
import { Trades } from './interest-trades';
import Transaction from './interest-transaction';
import { useSignedUserInfo } from '@/client/hooks/use-signed-user-info';
import { cn } from '@/client/utils';
import { api } from '@/client/utils/api';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

type Tab = {
  label: string;
  value: string;
};

export const WalletInterest = () => {
  const { t } = useTranslation();
  const tabs = useMemo(
    () => [
      {
        label: t('positions'),
        value: 'positions',
      },
      {
        label: t('trades'),
        value: 'trades',
      },
      {
        label: t('transaction'),
        value: 'transaction',
      },
    ],
    [t]
  );
  const [tab, setTab] = useState<Tab>(tabs[0]);
  const { data: singer } = useSignedUserInfo(api);
  if (!singer) {
    return null;
  }
  return (
    <div className="space-y-4">
      <div className="flex font-semibold space-x-5">
        {tabs.map(item => (
          <h4
            key={`tab-${item.value}`}
            className={cn('cursor-pointer', tab.value === item.value ? '' : 'op-40')}
            onClick={() => setTab(item)}
          >
            {item.label}
          </h4>
        ))}
      </div>
      {tab.value === 'positions' && <Positions uid={singer.uid} />}
      {tab.value === 'trades' && <Trades uid={singer.uid} />}
      {tab.value === 'transaction' && <Transaction uid={singer.uid} />}
    </div>
  );
};
